import { DateTime } from 'luxon';

import type { UserOrderLifetime } from 'models/userOrder';

import { isNumeric } from './number';
import { NEW_YORK_TIMEZONE } from './time';

export const getEndOfDayExpirationTs = (): number =>
    Math.floor(DateTime.now().setZone(NEW_YORK_TIMEZONE).endOf('day').valueOf() / 1000);

export const formatOrderExpiration = (lifetime: UserOrderLifetime): string =>
    lifetime === 'EOD'
        ? "Good 'til EOD"
        : isNumeric(lifetime)
          ? `Good 'til ${DateTime.fromSeconds(lifetime)
                .toLocal()
                .toLocaleString(DateTime.DATE_MED)} · ${DateTime.fromSeconds(lifetime)
                .toLocal()
                .toLocaleString(DateTime.TIME_SIMPLE)}`
          : "Good 'til canceled";

// All markets are eligible for bonus
export const isEligibleForBonus = () => true;
